//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import Table from '../../components/Table/Table.vue'
import { formatTrueFalse } from '../../components/helpers.js'

export default {
  components: {
    Table
  },
  props: {
    title: {
      type: String,
      default: null
    },
    additionalUrlParams: {
      type: String,
      default: null
    },
    selectedEmployee: {
      type: Object,
      default: null
    },
    showVehicleInfo: {
      type: Boolean,
      default: false
    },
    showQualifications: {
      type: Boolean,
      default: false
    },
    showMetroposition: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filteredEmployees: {
      type: Array,
      default: function () {
        return []
      }
    },
    hideEmployees: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      employees: [],
      columns: [
        {
          name: 'name',
          label: 'ФИО',
          align: 'left',
          field: 'name',
          sortable: true,
          width: 210,
          visible: true
        },
        {
          name: 'positionName',
          label: 'Должность',
          align: 'left',
          field: 'positionName',
          sortable: true,
          width: 170,
          visible: true
        },
        {
          name: 'metroPosition',
          label: 'Должность в допуске Метро',
          align: 'left',
          field: 'metroPosition',
          visible: this.showMetroposition
        },
        {
          name: 'performerSkills',
          label: 'Квалификации и допуски',
          align: 'center',
          field: 'performerSkills',
          sortable: true,
          width: 210,
          format: this.formatQualifications,
          visible: this.showQualifications
        },
        {
          name: 'consentToDrive',
          label: 'Согласен управлять транспортным средством',
          align: 'left',
          field: 'consentToDrive',
          sortable: true,
          width: 170,
          format: this.formatTrueFalse,
          visible: this.showVehicleInfo
        },
        {
          name: 'hasActivePreTripMedicalAdmittance',
          label: 'Есть действующий медосмотр',
          align: 'left',
          field: 'hasActivePreTripMedicalAdmittance',
          sortable: true,
          width: 210,
          format: this.formatTrueFalse,
          visible: this.showVehicleInfo
        },
        {
          name: 'vehicles',
          label: 'Выданные транспортные средства',
          align: 'left',
          field: 'vehicles',
          sortable: true,
          width: 210,
          format: this.formatVehicles,
          visible: this.showVehicleInfo
        }
      ],
      tempEmployee: this.multiple ? [] : null,
      loading: false,

      formatTrueFalse: formatTrueFalse,
      searchColumns: ['name', 'positionName']
    }
  },
  created: function () {
    this.getEmployees()
    if (this.selectedEmployee) {
      this.tempEmployee = this.selectedEmployee
    }
    this.columns = this.columns.filter((item) => item.visible)
  },
  methods: {
    formatQualifications: function (qualifications) {
      if (qualifications) {
        return qualifications.join(', ')
      }
    },
    formatVehicles: function (vehicles) {
      return vehicles.map(vehicle => vehicle.name + ' (' + vehicle.gosNumber + ')').join(', ')
    },
    isSelected: function (employee) {
      if (this.multiple) {
        return this.tempEmployee && this.tempEmployee.length && this.tempEmployee.find(e => e.key === employee.key)
      } else {
        return this.tempEmployee && employee && employee.id === this.tempEmployee.id
      }
    },
    onEmployeeSelected: function (employee) {
      if (this.multiple) {
        if (this.tempEmployee.find(e => e.key === employee.key)) {
          this.tempEmployee = this.tempEmployee.filter(e => e.key !== employee.key)
        } else {
          this.tempEmployee.push(employee)
        }
      } else {
        this.tempEmployee = employee
      }
    },
    onSaveEmployeeSelection: function () {
      this.$emit('save', this.tempEmployee)
      this.onCloseEmployeeModal()
    },
    onCloseEmployeeModal: function () {
      this.tempEmployee = this.multiple ? [] : null
      this.$emit('close')
    },
    getEmployees: function () {
      this.loading = true
      axiosGet({
        url: '/service/delta/employee/search?state=work' + (this.additionalUrlParams ? ('&' + this.additionalUrlParams) : ''),
        onSuccess: (response) => {
          this.employees = response.data.result
          if (this.filteredEmployees && this.filteredEmployees.length) {
            const filteredEmployeeKeys = this.filteredEmployees.map((employee) => employee.key)
            this.employees = this.employees.filter((employee) => filteredEmployeeKeys.includes(employee.key))
          }
          if (this.hideEmployees && this.hideEmployees.length) {
            const hideEmployeesKeys = this.hideEmployees.map((employee) => employee.key)
            this.employees = this.employees.filter((employee) => !hideEmployeesKeys.includes(employee.key))
          }
        },
        onFailure: 'Ошибка загрузки списка сотрудников',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
